async function postPayment(paymentRepository, data) {
    return await paymentRepository.postPayment(data)
}

async function postPaymentV8(paymentRepository, data) {
    return await paymentRepository.postPaymentV8(data)
}

export {postPayment, postPaymentV8}